module.exports = __webpack_public_path__ + "graphics/player-volume.ckh.387ca93eae04724165602076747ca8f2.svg";